import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { Button, Layout, Menu, Popconfirm, Row, Typography } from "antd";
import {
  ApartmentOutlined,
  BgColorsOutlined,
  PercentageOutlined,
  PlusCircleOutlined,
  SettingFilled,
  SettingOutlined,
  ShoppingCartOutlined,
  SkinOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import I18n from "../../i18n";
import Orders from "../Orders";
import Categories from "../Categories";
import Products from "../Products";
import Discounts from "../Discounts";
import NewProduct from "../NewProduct";
import NewDiscount from "../NewDiscount";
import Settings from "../Settings";
import { logOut } from "../../../application/auth-slice";
import { useAppDispatch } from "../../../application/store";
import EditProduct from "../EditProduct";
import HomeSettings from "../HomeSettings";
import Colors from "../Colors";

const { Header, Footer, Content, Sider } = Layout;

type RouteParams = {
  activeTab:
    | ""
    | "orders"
    | "categories"
    | "products"
    | "new-product"
    | "edit-product"
    | "discounts"
    | "new-discount"
    | "home-settings"
    | "settings"
    | "colors";
};

export default function Home() {
  const dispatch = useAppDispatch();
  const { activeTab } = useParams<RouteParams>();
  const history = useHistory();

  const goTo = (path: string) => history.push(path);

  const renderContent = () => {
    if (activeTab === "" || activeTab === "orders") return <Orders />;
    if (activeTab === "categories") return <Categories />;
    if (activeTab === "products") return <Products />;
    if (activeTab === "discounts") return <Discounts />;
    if (activeTab === "new-discount") return <NewDiscount />;
    if (activeTab === "new-product") return <NewProduct />;
    if (activeTab === "edit-product") return <EditProduct />;
    if (activeTab === "home-settings") return <HomeSettings />;
    if (activeTab === "settings") return <Settings />;
    if (activeTab === "colors") return <Colors />;
  };

  const getDefaultOpenKeys = () => {
    if (activeTab === "") return "orders";
    if (activeTab === "products" || activeTab === "new-product")
      return "products-menu";
    if (activeTab === "discounts" || activeTab === "new-discount")
      return "discounts-menu";
    return activeTab;
  };

  return (
    <Layout>
      <Header
        style={{
          position: "fixed",
          zIndex: 10,
          width: "100%",
          boxShadow: "0px -2px 4px 0px",
          padding: 0,
        }}
      >
        <Row justify="space-between" align="middle">
          <Typography.Title level={3} style={{ color: "#ffffff", margin: 12 }}>
            {I18n.title}
          </Typography.Title>
          <Popconfirm
            onConfirm={() => dispatch(logOut())}
            title={I18n.profile.logOutConfirmModal.description}
            placement="bottomRight"
          >
            <Button type="link" danger>
              {I18n.profile.logOut}
            </Button>
          </Popconfirm>
        </Row>
      </Header>
      <Layout style={{ marginTop: 64 }}>
        <Sider
          width={210}
          style={{
            overflow: "auto",
            height: "100vh",
            position: "fixed",
            right: 0,
          }}
        >
          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={[activeTab === "" ? "orders" : activeTab]}
            defaultOpenKeys={[getDefaultOpenKeys()]}
          >
            <Menu.Item
              key="orders"
              icon={<ShoppingCartOutlined />}
              onClick={() => goTo("/orders")}
            >
              {I18n.pages.orders}
            </Menu.Item>
            <Menu.SubMenu
              key="products-menu"
              title={I18n.pages.products}
              icon={<SkinOutlined />}
            >
              <Menu.Item
                key="products"
                icon={<UnorderedListOutlined />}
                onClick={() => goTo("/products")}
              >
                {I18n.pages.productsList}
              </Menu.Item>
              <Menu.Item
                key="new-product"
                icon={<PlusCircleOutlined />}
                onClick={() => goTo("/new-product")}
              >
                {I18n.pages.newProduct}
              </Menu.Item>
            </Menu.SubMenu>
            <Menu.Item
              key="colors"
              icon={<BgColorsOutlined />}
              onClick={() => goTo("/colors")}
            >
              رنگ‌ها
            </Menu.Item>
            <Menu.SubMenu
              key="discounts-menu"
              title={I18n.pages.discounts}
              icon={<PercentageOutlined />}
            >
              <Menu.Item
                key="discounts"
                icon={<UnorderedListOutlined />}
                onClick={() => goTo("/discounts")}
              >
                {I18n.pages.discountsList}
              </Menu.Item>
              <Menu.Item
                key="new-discount"
                icon={<PlusCircleOutlined />}
                onClick={() => goTo("/new-discount")}
              >
                {I18n.pages.newDiscount}
              </Menu.Item>
            </Menu.SubMenu>
            <Menu.Item
              key="categories"
              icon={<ApartmentOutlined />}
              onClick={() => goTo("/categories")}
            >
              {I18n.pages.categories}
            </Menu.Item>
            <Menu.Item
              key="home-settings"
              icon={<SettingFilled />}
              onClick={() => goTo("/home-settings")}
            >
              {I18n.pages.homeSettings}
            </Menu.Item>
            <Menu.Item
              key="settings"
              icon={<SettingOutlined />}
              onClick={() => goTo("/settings")}
            >
              {I18n.pages.settings}
            </Menu.Item>
          </Menu>
        </Sider>
        <Layout style={{ marginRight: 210 }}>
          <Content style={{ overflow: "initial" }}>{renderContent()}</Content>
          <Footer style={{ textAlign: "center", backgroundColor: "#f0f0f0" }}>
            {I18n.footer.copyright.replace("{year}", "1399")}
          </Footer>
        </Layout>
      </Layout>
    </Layout>
  );
}
